import { useJednotkaQuery } from '../api/JsdhNotifikaceService/service/AdminMutations';

/**
 * Limit vyjezdu a prepinac odpoctu dojezdu jednotky na jednom miste — cte je odpocet
 * (DojezdOdpocet) i oranzove zvyrazneni (useNestihaVyjezd) a nesmi se rozchazet.
 * `|| 10` shodne s hlavnim casovacem (CasOdVyhlaseni); `undefined` prepinace = zapnuto,
 * aby odpocet neproblikaval pri refetchi nebo se starsim backendem.
 */
export const useDojezdNastaveni = () => {
    const { data: jednotka } = useJednotkaQuery();
    return {
        casVyjezdMinuty: jednotka?.casVyjezdMinuty || 10,
        odpocetZapnut: jednotka?.dojezdOdpocetZapnut !== false,
    };
};
